"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPLOAD_FILE_HEADERS = exports.MAX_EMAIL_ATTACHMENT_FILE_SIZE_MB = exports.ATTACHMENT_MAX_FILE_SIZE = void 0;
exports.ATTACHMENT_MAX_FILE_SIZE = 20 * 1024 * 1024;
exports.MAX_EMAIL_ATTACHMENT_FILE_SIZE_MB = 10;
exports.UPLOAD_FILE_HEADERS = {
    FILE_NAME: "x-upload-file-name",
    FILE_TYPE: "x-upload-file-type",
};
